module.exports = __webpack_public_path__ + "static/img/db-life-smart-phone-sales.73c06d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/db-life-smart-phone-sales.jpg
// module id = QgYQ
// module chunks = 0